<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="existFlag"
            label="유해위험성 포함여부"
            v-model="searchParam.existFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="화학자재 유해위험성 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn label="" icon="help_outline">
            <template slot="tooltip">
              <q-popup-proxy>
                <c-table
                  title="유해위험성 구분 범례"
                  :columns="gridClass.columns"
                  :data="gridClass.data"
                  :gridHeight="gridClass.height"
                  hideBottom
                >
                </c-table>
              </q-popup-proxy>
            </template>
          </c-btn>
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "chemHarmfulRisk",
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: "Y",
        existFlag: null,
        mdmChemMaterialId: null,
      },
      useFlagItems: [
        { code: "Y", codeName: "유해위험성 포함" },
        { code: "N", codeName: "유해위험성 미포함" },
      ],
      grid: {
        columns: [
          {
            fix: true,
            name: "plantName",
            field: "plantName",
            label: "사업장명",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            fix: true,
            name: "materialCd",
            field: "materialCd",
            label: "자재코드",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            fix: true,
            name: "materialName",
            field: "materialName",
            label: "화학자재명",
            align: "left",
            type: "link",
            style: "width:200px",
            sortable: true,
          },
          {
            name: "propertiesStateName",
            field: "propertiesStateName",
            label: "성상",
            align: "center",
            style: "width:60px",
            sortable: true,
          },
          {
            name: "inputDissolutionTank",
            field: "inputDissolutionTank",
            label: "사용제품명",
            align: "center",
            style: "width:75px",
            sortable: true,
            isEllipsis: true
          },
          {
            name: "usageName",
            field: "usageName",
            label: "용도",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: "harmfulRisk",
            field: "harmfulRisk",
            label: "유해성·위험성",
            child: [
              {
                name: "hrc0000001",
                field: "hrc0000001",
                label: "급성독성(경구)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000002",
                field: "hrc0000002",
                label: "급성독성(경피)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000003",
                field: "hrc0000003",
                label: "급성독성(흡입)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000004",
                field: "hrc0000004",
                label: "피부 부식성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000005",
                field: "hrc0000005",
                label: "피부 자극성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000006",
                field: "hrc0000006",
                label: "심한 눈 손상성 또는 자극성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000007",
                field: "hrc0000007",
                label: "호흡기 과민성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000008",
                field: "hrc0000008",
                label: "피부 과민성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000009",
                field: "hrc0000009",
                label: "발암성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000010",
                field: "hrc0000010",
                label: "생식세포<br/>변이원성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000011",
                field: "hrc0000011",
                label: "생식독성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000012",
                field: "hrc0000012",
                label: "특정표적장기 독성(1회 노출)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000013",
                field: "hrc0000013",
                label: "특정표적장기 독성(반복 노출)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000014",
                field: "hrc0000014",
                label: "흡인유해성",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000015",
                field: "hrc0000015",
                label: "금속부식성 물질",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000016",
                field: "hrc0000016",
                label: "인화성 가스",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000017",
                field: "hrc0000017",
                label: "인화성 액체",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000018",
                field: "hrc0000018",
                label: "고압가스",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000019",
                field: "hrc0000019",
                label: "수생환경 유해성(급성)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000020",
                field: "hrc0000020",
                label: "수생환경 유해성(만성)",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
              {
                name: "hrc0000021",
                field: "hrc0000021",
                label: "자기발열성 물질 및 혼합물",
                align: "center",
                style: "width:100px",
                sortable: true,
                type: "html",
              },
            ],
          },
        ],
        data: [],
      },
      gridClass: {
        columns: [
          {
            fix: true,
            name: "harmfulRiskClassName",
            field: "harmfulRiskClassName",
            label: "유해위험성구분",
            align: "center",
            style: "width:130px",
            sortable: true,
          },
          {
            name: "gubun1",
            field: "gubun1",
            label: "구분1",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun1a",
            field: "gubun1a",
            label: "구분1A",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun1b",
            field: "gubun1b",
            label: "구분1B",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun1c",
            field: "gubun1c",
            label: "구분1C",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun2",
            field: "gubun2",
            label: "구분2",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun2a",
            field: "gubun2a",
            label: "구분2A",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun2b",
            field: "gubun2b",
            label: "구분2B",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun3",
            field: "gubun3",
            label: "구분",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun4",
            field: "gubun4",
            label: "구분",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
          {
            name: "gubun5",
            field: "gubun5",
            label: "구분",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "html",
          },
        ],
        data: [],
        height: "500px",
      },
      editable: true,
      listUrl: "",
      listLegendUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.mam.chem.harmfulList.url;
      this.listLegendUrl = selectConfig.mdm.mam.chem.harmfulLegendList.url;
      // code setting
      // list setting
      this.getLegend();
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    getLegend() {
      this.$http.url = this.listLegendUrl;
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.gridClass.data = _result.data;
      });
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = "화학자재 상세";
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : "",
        plantCd: row ? row.plantCd : "",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/mdm/mam/chemDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
